module.exports = __webpack_public_path__ + "static/media/Johns Hopkins University Lyme Dashboard.b4fe1232.mp4";